import { devLogError } from "@/lib/sentryCaptureException";
import { useSignIn } from "../store/signIn/index";
import { eCRMEvent } from "@/lib/eCRMEvent";
import { ECRM_EVENT_LIST } from "@/constants/eventList";
import { clearToken, setSessionStorage } from "./storage";
import { isNumber } from "./validations";

// let deferredPrompt;
let collectedObjectURLs = [];

export const arrayMaker = (size = 1) => {
  return Array.from({ length: size }, (_, i) => i + 1);
};

export const lazyRetry = function (componentImport) {
  return new Promise((resolve, reject) => {
    componentImport()
      .then((component) => {
        resolve(component);
      })
      .catch((error) => {
        console.log("!@#$%^&*** lazyRetry error  ====>", error);
        window.location.reload();
        reject(error);
      });
  });
};

export const getDocumentElm = (elemId) => {
  if (typeof document !== "undefined") {
    return document.getElementById(`${elemId}`);
  }
};

export const isObjEmpty = (obj) => {
  // because Object.keys(new Date()).length === 0;
  // we have to do some additional check
  return obj === null || obj === "undefined"
    ? true
    : !!obj && // 👈 null and undefined check
        Object.keys(obj).length === 0 &&
        Object.getPrototypeOf(obj) === Object.prototype;
};

export const objLength = (obj) => {
  // because Object.keys(new Date()).length === 0;
  // we have to do some additional check
  return (
    obj && // 👈 null and undefined check
    Object.getPrototypeOf(obj) === Object.prototype &&
    Object.keys(obj).length
  );
};

export const stopPropagate = (e) => {
  try {
    e.stopPropagation();
  } catch (error) {
    // // SentryCaptureException(error);
    devLogError(error);
  }
};

// export const setDeferredPrompt = (_deferVar) => {
//   deferredPrompt = _deferVar;
// };

export const isRTL = (string) => {
  try {
    if (string?.indexOf("؟") !== -1) {
      return true;
    } else {
      let weakChars =
          "\u0000-\u0040\u005B-\u0060\u007B-\u00BF\u00D7\u00F7\u02B9-\u02FF\u2000-\u2BFF\u2010-\u2029\u202C\u202F-\u2BFF",
        rtlChars = "\u0591-\u07FF\u200F\u202B\u202E\uFB1D-\uFDFD\uFE70-\uFEFC",
        rtlDirCheck = new RegExp(`^[${weakChars}]*[${rtlChars}]`);

      return rtlDirCheck.test(string.trim());
    }
  } catch (error) {
    // // SentryCaptureException(error);
    devLogError(error);
  }
};

export const fileType = (item) => {
  try {
    return item?.type?.startsWith("image")
      ? "image"
      : item?.type?.startsWith("video")
        ? "video"
        : item?.type;
  } catch (error) {
    console.error("# fileType error", error);
    return "";
  }
};

export const anchorOnTheFly = (url, _target, _download) => {
  try {
    let a = document.createElement("a");
    a.style.display = "none";
    a.href = url;
    a.download = _download ? _download : undefined;
    a.target = _target ? _target : undefined;
    document.body.appendChild(a);
    a.click();
    let _timeOut;
    const _clearChild = () => {
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      clearTimeout(_timeOut);
    };
    _timeOut = setTimeout(_clearChild, 100);
  } catch (error) {
    console.log("$$ error on anchorOnTheFly:", error);
  }
};

export const addCountryCode = (string) => {
  const removeZero = string.slice("1");
  return "+98" + removeZero;
};

export const removeCountryCode = (string) => {
  if (string) {
    const removeCode = string?.slice("3");
    return "0" + removeCode;
  }
};

export const formDataMaker = (_file) => {
  const FData = new FormData();
  FData.append("mediaFile", _file);
  return FData;
};

export const navigatorCopy = async (text, next) => {
  try {
    if ("clipboard" in navigator) {
      await navigator.clipboard
        .writeText(text)
        .then(() => (next && typeof next === "function" ? next() : null));
    }
  } catch (error) {
    // // SentryCaptureException(error);
    devLogError(error);
  }
};
export const navigatorShare = async ({ title, text, url }) => {
  try {
    if (typeof window !== "undefined" && navigator.canShare) {
      await navigator.share({
        title,
        text,
        url,
      });
    }
  } catch (error) {
    // SentryCaptureException(error);
    devLogError(error);
  }
};

export const toEnglishNumber = (str) => {
  const persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
    arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
  if (typeof str === "string") {
    for (let i = 0; i < 10; i++) {
      str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
    }
  }
  return str;
};

export const toFarsiNumber = (num) => {
  const farsiDigits = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
  return String(num).replace(/\d/g, (x) => farsiDigits[x]);
};

export function removePriceFormater(price) {
  return toEnglishNumber(price).replace(/[^0-9\.-]+/g, ""); //eslint-disable-line
}

export const objectKeys = (obj) => {
  return Object.keys(obj);
};

export const noArrProps = [];
export const noObjProps = {};
export const noFnProps = () => {}; //eslint-disable-line
export const noRenderProps = () => <></>;

const handleECRMLogout = () => {
  try {
    eCRMEvent(ECRM_EVENT_LIST.logout);
  } catch (error) {
    // SentryCaptureException(error);
    devLogError(error);
  }
};

export const forceToLogOut = (message, url = "", status = "") => {
  try {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      for (const registration of registrations) {
        registration.unregister();
      }
    });
    if (process.env.NEXT_PUBLIC_ENVIROMENT === "develop") {
      const _error = new Error(`${message} | ${url} | ${status}`);
      // SentryCaptureException(_error);
      devLogError(_error);
    }
    // Logging out the user by removing all the tokens from local
    clearToken();
    // Redirecting the user to the landing page
    const signInUrl = `${window.location.origin}/sign-in${window.location.search}`;
    window.location.href = signInUrl;
    handleECRMLogout();
    useSignIn.setState();
  } catch (error) {
    // SentryCaptureException(error);
    devLogError(error);
  }
};
export const setCurrentPathname = (_pathName) => {
  if (typeof window !== "undefined") {
    setSessionStorage("pathName", _pathName);
  }
};

export const currencyFormater = (number, isRial = true) => {
  if (number < 0) {
    return "";
  }
  try {
    let _number;
    switch (typeof number) {
      case "number":
        _number = isRial ? Math.floor(number * 0.1) : number;
        break;
      case "string":
        _number = isRial ? number.slice(0, -1) : number;
        break;
      default:
        _number = 0;
        break;
    }
    const intlNum = new Intl.NumberFormat("fa-IR");
    return intlNum.format(_number);
  } catch (error) {
    // SentryCaptureException(error);
    devLogError(error);
    return 0;
  }
};

export const createSrc = (blob) => {
  if (typeof window !== "undefined" && URL) {
    const _createdSrc = URL.createObjectURL(blob);
    collectedObjectURLs.push(_createdSrc);
    return _createdSrc;
  }
};

export const scaleLargeNum = (number) => {
  if (!isNumber(number)) {
    return "";
  }
  if (number >= 1000000) {
    const Millions = Math.floor(number / 1000000);
    const hundreds = Math.floor((number % 1000000) / 1000 / 100);
    return hundreds
      ? `${toFarsiNumber(Millions)}.${toFarsiNumber(hundreds)}M`
      : `${toFarsiNumber(Millions)}M`;
  } else if (number >= 1000) {
    const Millennials = Math.floor(number / 1000);
    const hundreds = Math.floor((number % 1000) / 100);
    return hundreds
      ? `${toFarsiNumber(Millennials)}.${toFarsiNumber(hundreds)}K`
      : `${toFarsiNumber(Millennials)}K`;
  } else {
    return toFarsiNumber(number);
  }
};

export const camelToSnakeCase = (str) => {
  try {
    return str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
  } catch (error) {
    // SentryCaptureException(error);
    devLogError(error);
    return str;
  }
};

export const cleanUrl = (url) => {
  try {
    if (url) {
      return url.replace(/^(https?:\/\/)?(www\.)?|\/$/g, "");
    } else {
      return "";
    }
  } catch (error) {
    // SentryCaptureException(error);
    devLogError(error);
    return "";
  }
};

export const isLocalhost =
  typeof window !== "undefined" &&
  Boolean(
    window.location.hostname === "localhost" ||
      // [::1] is the IPv6 localhost address.
      window.location.hostname === "[::1]" ||
      // 127.0.0.1/8 is considered localhost for IPv4.
      window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
  );

export const revokeSrc = () => {
  try {
    if (typeof window !== "undefined" && URL && collectedObjectURLs.length) {
      collectedObjectURLs.forEach((item) => URL.revokeObjectURL(item));
      collectedObjectURLs = [];
    }
  } catch (error) {
    // SentryCaptureException(error);
    devLogError(error);
  }
};

export const isNAN = (value) => {
  return Number.isNaN(value);
};
